module.exports = {
  GLOBAL: 'Treasure',
  VERSION: '2.1.0',
  HOST: 'in.treasuredata.com',
  DATABASE: '',
  PATHNAME: '/js/v3/event/'
}
